function getRaisesNonRaises({ actions }) {
  const raises = actions.filter(i => i.type === 'RAISE')
  const nonRaises = actions.filter(i => i.type !== 'RAISE')
  return { raises, nonRaises }
}

function get4RaiseGroups({ raises, order = 'asc' }) {
  const betRaise = raises[0]?.raise_alias ? 'bet' : 'raise'

  const small = {
    id: 'bet_small',
    type: 'RAISE',
    group_display_name: `${betRaise}_small`,
    css_class: 'R1',
    hex: 'var(--clr-R1-initial)',
    action: {},
    actions: [],
  }
  const medium = {
    id: 'bet_medium',
    type: 'RAISE',
    group_display_name: `${betRaise}_medium`,
    css_class: 'R2',
    hex: 'var(--clr-R2-initial)',
    action: {},
    actions: [],
  }
  const large = {
    id: 'bet_large',
    type: 'RAISE',
    group_display_name: `${betRaise}_large`,
    css_class: 'R3',
    hex: 'var(--clr-R3-initial)',
    action: {},
    actions: [],
  }
  const overbet = {
    id: 'bet_overbet',
    type: 'RAISE',
    group_display_name: `${betRaise}_overbet`,
    css_class: 'R4',
    hex: 'var(--clr-R4-initial)',
    action: {},
    actions: [],
  }

  raises.forEach(a => {
    // console.log(a)
    if (a.raise_group === 'bet_overbet') {
      overbet.actions.push(a)
    } else if (a.raise_group === 'bet_large') {
      large.actions.push(a)
    } else if (a.raise_group === 'bet_medium') {
      medium.actions.push(a)
    } else if (a.raise_group === 'bet_small') {
      small.actions.push(a)
    }
  })
  let raiseGroups = []
  if (order === 'asc') {
    raiseGroups = [small, medium, large, overbet]
  } else {
    raiseGroups = [overbet, large, medium, small]
  }
  // console.log(raiseGroups)
  return raiseGroups
}

function getImportantActions({ actions, max = 6, sortKey = 'strategy', raisesFirst = true }) {
  let res = null

  let { raises, nonRaises } = getRaisesNonRaises({ actions })
  const toMax = max - nonRaises.length

  raises.sort((a, b) => (a[sortKey] < b[sortKey] ? 1 : -1))
  raises = raises.slice(0, toMax)

  raises.sort((a, b) => (a.raise_amount < b.raise_amount ? 1 : -1))
  if (raisesFirst) {
    res = [...raises, ...nonRaises]
  } else {
    res = [...nonRaises, ...raises]
  }
  return res
}

function getRaiseGroupedValues({ actions, groupValues }) {
  let res = groupValues.reduce((a, b) => {
    a[b] = 0
    return a
  }, {})
  res = actions.reduce((a, b) => {
    groupValues.forEach(key => {
      a[key] += b[key]
    })
    return a
  }, res)
  return res
}

function getRaiseGroupedStrategyEvEq({ actions }) {
  const res = actions.reduce(
    (a, b) => ({
      strategy: a.strategy + b.strategy,
      ev: a.ev + b.strategy * b.ev,
      eq: a.eq + b.strategy * b.eq,
    }),
    {
      strategy: 0,
      ev: 0,
      eq: 0,
    },
  )
  res.ev /= res.strategy || 1
  res.eq /= res.strategy || 1
  return res
}

function getGroupedActions({
  actions,
  grouping = 'swv_grouping_none',
  groupValues = ['total_frequency'],
  groupValuesFunction = getRaiseGroupedValues,
  raisesFirst = true,
}) {
  // console.log(actions)
  let res = null
  if (grouping === 'swv_grouping_none') {
    const { raises, nonRaises } = getRaisesNonRaises({ actions })
    if (raisesFirst) {
      res = [...raises, ...nonRaises]
    } else {
      res = [...nonRaises, ...raises]
    }
  } else if (grouping === 'swv_grouping_4') {
    const { raises, nonRaises } = getRaisesNonRaises({ actions })
    let raiseGroups = get4RaiseGroups({ raises, order: raisesFirst ? 'desc' : 'asc' })
    raiseGroups = raiseGroups.filter(a => a.actions.length)
    raiseGroups = raiseGroups.map(g => {
      const groupedValues = groupValuesFunction({
        actions: g.actions,
        groupValues,
      })
      const r = {
        ...g,
        action: g.css_class,
        css_class: g.css_class,
        ...groupedValues,
      }
      return r
    })
    if (raisesFirst) {
      res = [...raiseGroups, ...nonRaises]
    } else {
      res = [...nonRaises, ...raiseGroups]
    }
  } else if (grouping === 'swv_grouping_all') {
    const { raises, nonRaises } = getRaisesNonRaises({ actions })
    const groupedValues = groupValuesFunction({
      actions: raises,
      groupValues,
    })
    let raise = raises[0]
    if (raise) {
      raise = [
        {
          id: 'bet_all',
          action: 'R',
          type: 'RAISE',
          css_class: 'R1',
          hex: 'var(--clr-R_default-initial)',
          group_display_name: raise?.raise_alias ? 'bet_all' : 'raise_all',
          actions: raises,
          ...groupedValues,
        },
      ]
    } else {
      raise = []
    }
    if (raisesFirst) {
      res = [...raise, ...nonRaises]
    } else {
      res = [...nonRaises, ...raise]
    }
  }
  // console.log(res)
  const l = res.length
  // if (raisesFirst) {
  //     res = [...raiseGroups, ...nonRaises]
  // } else {
  //     res = [...nonRaises, ...raiseGroups]
  // }
  res = res.map((a, idx) => ({
    ...a,
    grouped_order: idx,
    grouped_order_reverse: l - idx,
  }))
  return res
}

function getUngroupedActions({ actions, orderKey = 'order_reverse' }) {
  let res = []
  actions.forEach(a => {
    if (a.actions) {
      res = [...res, ...a.actions]
    } else {
      res = [...res, a]
    }
  })
  res = res.sort((a, b) => (a[orderKey] < b[orderKey] ? -1 : 1))
  return res
}

function getSortedActions({ actions, raisesFirst = true }) {
  actions = actions.map(a => a)
  const { raises, nonRaises } = getRaisesNonRaises({ actions })

  const orderDict = {
    FOLD: 1,
    CALL: 2,
    CHECK: 3,
  }

  nonRaises.sort((a, b) => (orderDict[a.type] > orderDict[b.type] ? -1 : 1))
  raises.sort((a, b) => (a.raise_amount > b.raise_amount ? -1 : 1))

  let res = []
  if (raisesFirst) {
    res = [...raises, ...nonRaises]
  } else {
    res = [...nonRaises, ...raises]
  }
  // console.log(res)
  return res
}

export {
  getRaisesNonRaises,
  get4RaiseGroups,
  getImportantActions,
  getGroupedActions,
  getUngroupedActions,
  getRaiseGroupedStrategyEvEq,
  getSortedActions,
}
